import React from 'react';
import api from 'src/helpers/api'

export default class Image extends React.Component {

  initialState = {
    content: "",
    uploading: false,
    uploadProgress: 0,
    uploadError: ""
  }

  state = this.initialState

  upload = null

  componentWillMount() {
    let content = this.props.content
    this.setState({
      content: this.props.content,
      uploading: false
    })
  }

  handleChange = (e) => {
    console.log("handleChange",e.target.value)
    el.content = e.target.value
    this.setState({content: e.target.value});    
    // this.props.root.handleChangeContent(this.props.el,e.target.value)
  }

  handleUpload = (e) => {
    if (this.state.uploading) return true;
    this.setState({
      uploading: true,
      uploadError: "",
      uploadProgress: 0
    })
    // console.log("uploadImage",fd)
    let onProgress = (e,uploadProgress)=> {
      this.setState({uploadProgress})
    }
    api("news/upload",{"file": e.target.files[0]},true,onProgress)
      .then(res => {
        if (this.upload) this.upload.value = null
        console.log("news/upload res:",res)      
        if (res && res.url && res.result == 1) {
          this.props.el.content = res.url
          this.setState({
            uploading: false,
            content: res.url,
            uploadProgress: 0,
            uploadError: ""
          })
        } else {
          this.setState({
            uploading: false,
            content: "",
            uploadProgress: 0,
            uploadError: res && res.error && res.error.toString() || "Failed"
          })
        }
    })    
    console.log("handleUpload")
  }

  handleClickUpload = (e) => {
    e.preventDefault()
    e.stopPropagation()
    this.upload.click()
  }
  handleFileClick = (e) => {
    e.stopPropagation()
  }
  handleClickUrl = (e) => {
    e.stopPropagation()
    e.preventDefault()
    let url = prompt("Image url")
    if (!url) return;
    this.props.el.content = url
    this.setState({
      content: url
    })
    console.log({url})
  }

  render() {
    let editMode = this.props.mode == 'edit'
    let content = editMode ? this.state.content || this.props.content : this.props.content
    if (typeof content != "string") content = "";
    this.props.el.content = content
    if (editMode) {
      return (
        <div style={{height: "inherit"}}>
          {content.length > 0 &&
            <img 
              class={"news-image mb-1 mode-"+this.props.mode} 
              src={content} 
              alt="upload"
              
              />
          }     
          {this.state.uploading &&
            <div>Uploading {this.state.uploadProgress}%</div>
          }
          {!this.state.uploading && 
            <div class="text-center news-image-upload-buttons">
              <input 
                type="file" 
                ref={(ref) => this.upload = ref} 
                onChange={this.handleUpload}
                onClick={this.handleFileClick}
                class="d-none"
                // style={{position: 'absolute'}}
              />
              <button class='btn btn-sm warning' onClick={this.handleClickUpload}>Upload</button>
              <button class='btn btn-sm primary ml-2' onClick={this.handleClickUrl}>Url</button>
            </div>
          }
                    
        </div>
      )
    } else if (content) {
      return <img class={"news-image mode-"+this.props.mode} src={content} />
    } else {
      return <div></div>
    }
  }

}